import { commands } from "./geozone.command";
export const geoZone = {
  commands: commands,
};
